"use client"
import { LoadingOutlined } from "@ant-design/icons"
import { ComponentConfig } from "@measured/puck"
import { message, Spin } from "antd"
import { useEffect, useState } from "react"
import { fetchDepartment, fetchRecruitments } from "../../../../../../modules/recruitment/services/recruitment"
import { DepartmentData, RecruitmentData } from "../../../types"
import { PopupRegister } from "./PopupRegister"
import "./styles.modules.css"
export interface SectionFilterProps {
  heading1: string
  text1: string
  text2: string
  heading2: string
  text3: string
  text4: string
  heading3: string
  text5: string
  text6: string
}

export const RenderConfig: ComponentConfig<SectionFilterProps> = {
  render: (props: SectionFilterProps) => {
    const [data, setData] = useState<RecruitmentData[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [departments, setDepartments] = useState<DepartmentData[]>([])
    const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined)
    const [selectedPosition, setSelectedPosition] = useState<number>()
    const [selectedDepartment, setSelectedDepartment] = useState<string>("")
    const [selectedRank, setSelectedRank] = useState<string>("")

    const fetchData = async (searchTerm?: { department?: string; rank?: string }) => {
      setLoading(true)
      try {
        const response = await fetchRecruitments()
        if (searchTerm) {
          const filteredData =
            response.data?.filter((item: any) => {
              const matchesDepartment = searchTerm.department
                ? item.attributes.Department?.toLowerCase() === searchTerm.department.toLowerCase()
                : true
              const matchesRank = searchTerm.rank
                ? item.attributes.Rank?.toLowerCase() === searchTerm.rank.toLowerCase()
                : true
              return matchesDepartment && matchesRank
            }) || []

          setData(filteredData)
        } else {
          setData(response.data || [])
        }
      } catch (error) {
        message.error("Failed to fetch recruitment data")
      } finally {
        setLoading(false)
      }
    }

    useEffect(() => {
      const fetchAllData = async () => {
        await fetchData()
        try {
          const departmentResponse = await fetchDepartment()
          setDepartments(departmentResponse.data || [])
        } catch (error) {
          message.error("Failed to fetch department data")
        }
      }

      fetchAllData()
    }, [])

    const handleDepartmentClick = (e: React.MouseEvent<HTMLAnchorElement>, department: string) => {
      e.preventDefault()
      setSelectedDepartment(department)
      fetchData({ department, rank: selectedRank })
    }

    const handleRankClick = (e: React.MouseEvent<HTMLAnchorElement>, rank: string) => {
      e.preventDefault()
      setSelectedRank(rank)
      fetchData({ department: selectedDepartment, rank })
    }

    return (
      <div className="w-[1170px] px-[15px] mx-auto max-sm:w-full">
        <div className="flex justify-between max-sm:flex-col">
          <div
            id="col-1"
            className="w-[25%] p-[25px] bg-[#F9F9F9] rounded-[16px] text-black max-sm:w-full max-sm:p-[15px] h-fit"
          >
            <h3
              className="font-bold text-[24px] relative"
              style={{
                background: "-webkit-linear-gradient(62.29deg, #5bb97a 13.03%, #298cca 89.38%)",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {props.heading1}
            </h3>
            <div className="max-sm:flex max-sm:justify-between max-sm:mt-[5px] max-sm:mb-[5px]">
              <div className="mt-[40px]">
                <h5 className="font-bold text-[17px] mb-[15px]">Phòng ban</h5>
                <p className="text-[14px] mb-[15px] font-semibold">
                  <a
                    href="/"
                    onClick={e => {
                      handleDepartmentClick(e, "")
                      setIsOpen(undefined)
                    }}
                  >
                    Tất cả
                  </a>
                </p>
                <div>
                  {departments.map(department => (
                    <p key={department.attributes.Name} className="text-[14px] mb-[15px] font-semibold">
                      <a
                        href="/"
                        onClick={e => {
                          handleDepartmentClick(e, department.attributes.Name)

                          setIsOpen(undefined)
                        }}
                      >
                        {department.attributes.Name}
                      </a>
                    </p>
                  ))}
                </div>
              </div>
              <div className="mt-[40px] max-sm:text-end max-sm:mb-[10px] max-sm:pr-[3px]">
                <a onClick={e => handleRankClick(e, "")}>
                  <h5 className="font-bold text-[17px] mb-[15px]">Cấp bậc</h5>
                </a>
                <p className="text-[14px] mb-[15px]">
                  <a href="/" onClick={e => handleRankClick(e, "Nhân viên")}>
                    Nhân viên
                  </a>
                </p>
                <p className="text-[14px] mb-[15px]">
                  <a href="/" onClick={e => handleRankClick(e, "Quản lý")}>
                    Quản lý
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="w-[70%] p-[25px] max-sm:w-full max-sm:pt-[25px] max-sm:pb-[65px] max-sm:px-0 text-[#283248]">
            <div className="flex flex-row items-center justify-between pb-8 border-b border-[#f3f3f3]">
              <h3 className="font-bold text-[24.5px] max-sm:text-[19.6px] max-sm:leading-[23px]">{props.heading2}</h3>
              <h3 className="text-[17px] font-semibold text-[#8d8b8b] max-sm:text-[14px] max-sm:w-[43%] text-right">
                {data.length} Vị trí tuyển dụng
              </h3>
            </div>
            <div className="pt-[10px] max-sm:pl-0">
              {loading ? (
                <div className=" inset-0 flex items-center justify-center bg-white bg-opacity-50">
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 60,
                        }}
                        spin
                      />
                    }
                  />
                </div>
              ) : (
                <div className="space-y-4">
                  {selectedPosition && <PopupRegister isOpen={isOpen} data={data} position={selectedPosition} />}
                  {data.length > 0 ? (
                    data.map(item => (
                      <div
                        key={item.id}
                        className="flex flex-col p-4 bg-white border-[0.5px] shadow-md rounded-lg hover:scale-105 transform transition-all duration-300 cursor-pointer"
                        onClick={() => {
                          setSelectedPosition(item.id)
                          if (isOpen == undefined) {
                            setIsOpen(false)
                          } else setIsOpen(!isOpen)
                        }}
                      >
                        <div>
                          <h4 className="text-lg font-bold">{item.attributes.Title}</h4>
                        </div>
                        <div className="flex flex-row justify-between mt-2">
                          <div className="flex justify-between flex-col sm:flex-row sm:gap-8 text-sm">
                            {item.attributes.Quantity && <p>Số lượng: {item.attributes.Quantity}</p>}
                            {item.attributes.Rank && <p>Cấp bậc: {item.attributes.Rank}</p>}
                          </div>
                          <div className="flex flex-col text-right sm:flex-row gap-1">
                            {item.attributes.Department && item.attributes.Department}
                            <div className="hidden sm:block">-</div>
                            {item.attributes.company && <strong>{item.attributes.company}</strong>}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center justify-center h-[100px]">
                      <p>Vị trí hiện không khả dụng </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  },
}
